module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirm()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pb-0"
  }, [_c('input', {
    ref: "pick",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.broadcastInput()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pickFile()
      }
    }
  }, [_c('v-icon', {
    staticClass: "text-xs-justify",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("backup")])], 1), _vm._v(" "), _c('h6', {
    staticClass: "text-xs-center mt-2"
  }, [_vm._v("Click to choose a file")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("* " + _vm._s(_vm.formats.toString()))])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit"
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0a07e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileUploadComponent.vue
// module id = 959
// module chunks = 5 8 14 16 17 30